import React from "react";
import { Page, View, Text, Image, StyleSheet } from "@react-pdf/renderer";
import { PDF_PAGE } from "../../constants/pdfSizes";
import defaultCover from "../../assets/flightBg.jpg";

const styles = StyleSheet.create({
  page: {
    width: PDF_PAGE.width,
    height: PDF_PAGE.height,
    position: "relative",
    backgroundColor: "#000",
  },
  background: {
    position: "absolute",
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(55,46,112,0.75)",
  },
  container: {
    paddingTop: 10,
    paddingHorizontal: 0,
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  headerIcon: {
    width: 40,
    height: 40,
    alignSelf: "center",
    marginBottom: 10,
    marginTop: 20,
  },
  title: {
    fontFamily: "Montserrat",
    fontSize: 44,
    textAlign: "center",
    color: "#fff",
    fontWeight: "medium",
    marginBottom: 0,
  },
  subtitle: {
    fontFamily: "Montserrat",
    fontSize: 20,
    textAlign: "center",
    color: "#fff",
    marginBottom: 10,
  },
  cardsWrapper: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    gap: 16,
    width: "100%",
    paddingHorizontal: 20,
    marginTop: 40,
  },
  cardContainer: {
    borderWidth: 1,
    borderColor: "rgba(241, 177, 211, 1)",
    borderRadius: 10,
    padding: 12,
    marginBottom: 15,
    width: "23%",
    backgroundColor: "transparent",
    position: "relative",
  },
  labelBox: {
    backgroundColor: "#fff",
    borderRadius: 5,
    paddingVertical: 8,
    paddingHorizontal: 10,
    alignSelf: "center",
    marginBottom: 8,
    width: "90%",
    textAlign: "center",
    marginTop: "-30",
    color: "#090F49",
    justifyContent: "center",
    alignItems: "center",
    borderColor: "rgba(241, 177, 211, 1)",
    borderWidth: 1,
  },
  labelText: {
    fontSize: 15,
    fontWeight: "bold",
    color: "#2a0e54",
    textAlign: "center",
    fontWeight: "bold",
    fontFamily: "Montserrat",
  },
  timeText: {
    fontSize: 24,
    color: "#a6ff00",
    fontWeight: "bold",
    textAlign: "center",
    fontFamily: "Montserrat",
    paddingTop: 15,
  },
  dateText: {
    fontSize: 24,
    color: "#fff",
    textAlign: "center",
    marginBottom: 8,
    fontFamily: "Montserrat",
    fontWeight: "medium",
  },
  airlineBox: {
    borderWidth: 1,
    backgroundColor: "#6E4D69",
    borderColor: "#F1B1D3",
    borderRadius: 4,
    paddingVertical: 4,
    paddingHorizontal: 10,
    alignSelf: "center",
    marginBottom: 8,
    marginVertical: 10,
  },
  airlineText: {
    color: "#fff",
    fontSize: 12,
    fontWeight: "bold",
    textTransform: "uppercase",
    textAlign: "center",
    fontFamily: "Montserrat",
  },
  cityText: {
    fontSize: 22,
    color: "#fff",
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: 4,
    fontFamily: "Montserrat",
    textTransform: "uppercase",
  },
  airportText: {
    fontSize: 13,
    color: "#fff",
    textAlign: "center",
    textTransform: "uppercase",
    lineHeight: 1.1,
    paddingBottom: 15,
  },
  lineWrapper: {
    width: "100%",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "flex-start",
  },

  gradientLine: {
    width: "50%",
    height: 2,
    backgroundColor: "#a68ddc",
    opacity: 0.5, 
    borderRadius: 1,
    marginRight: 0,
    marginTop: 8,
  },

  planeIcon: {
    width: 16,
    height: 16,
  },
});

const FlightSlide = ({
  bg,
  title = "FLIGHT DETAILS",
  subtitle = "Your Journey Awaits",
  flights = [],
  icon,
}) => {
  const data = flights.slice(0, 4);
  const backgroundImage = bg || defaultCover;
  return (
    <Page size={PDF_PAGE} style={styles.page}>
      <Image src={backgroundImage} style={styles.background} />
      <View style={styles.overlay} />
      <View style={styles.container}>
        <View style={styles.lineWrapper}>
          <View style={styles.gradientLine} />
          {icon && <Image src={icon} style={styles.headerIcon} />}
        </View>

        <Text style={styles.title}>{title}</Text>
        <Text style={styles.subtitle}>{subtitle}</Text>

        <View style={styles.cardsWrapper}>
          {data.map((segment, idx) => (
            <View key={idx} style={styles.cardContainer}>
              <View style={styles.labelBox}>
                <Text style={styles.labelText}>
                  {segment.type?.toUpperCase() || "DEPARTURE"}
                </Text>
              </View>
              <Text style={styles.timeText}>{segment.time || "--:--"} HRS</Text>
              <Text style={styles.dateText}>{segment.date || "DATE"}</Text>

              <View style={styles.airlineBox}>
                <Text style={styles.airlineText}>
                  {segment.airline || "AIRLINE"}
                </Text>
              </View>

              <Text style={styles.cityText}>
                {(segment.city || "CITY").length > 10
                  ? `${segment.city.slice(0, 10)}...`
                  : segment.city || "CITY"}
              </Text>
              <Text style={styles.airportText}>
                {segment.airport || "AIRPORT NAME"}
              </Text>
            </View>
          ))}
        </View>
      </View>
    </Page>
  );
};

export default FlightSlide;
